// ItemDTO.js
// Data Transfer Object for GW2 Item

class ItemDTO {
    // TODO: add more fields as needed, for now we just want id and count for the guild stash items (we can fetch the item details separately if needed)
    constructor({
        id,
        count,
        name,
        type,
        rarity,
        vendor_value,
        chat_link,
        icon,
        image_url,
        details

    }) {
        this.id = id;
        this.count = count;
        this.name = name;
        this.type = type;
        this.rarity = rarity;
        this.vendor_value = vendor_value;
        this.chat_link = chat_link;
        this.icon = icon;
        this.image_url = image_url; // gets set from gw2 wiki url
        this.details = details; // can be null or object with string type and skin integer id
    }
}

module.exports = ItemDTO;